import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const IconPlay = (props: SvgIconProps) => {
  const { sx, ...other } = props;
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      viewBox="0 0 24 24"
      preserveAspectRatio="xMidYMid meet"
      sx={{
        ...sx,
      }}
      {...other}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.86968 3.45564L19.1467 11.1206C19.3007 11.2098 19.4286 11.3379 19.5176 11.4921C19.6065 11.6463 19.6533 11.8211 19.6533 11.9991C19.6533 12.1771 19.6065 12.352 19.5176 12.5062C19.4286 12.6604 19.3007 12.7885 19.1467 12.8776L5.86968 20.5436C5.71535 20.6332 5.54011 20.6805 5.36166 20.6807C5.18322 20.6808 5.00789 20.6339 4.85338 20.5446C4.69887 20.4554 4.57066 20.3269 4.48169 20.1722C4.39272 20.0175 4.34615 19.8421 4.34668 19.6636V4.33464C4.34664 4.1564 4.39353 3.98129 4.48264 3.82692C4.57175 3.67255 4.69994 3.54437 4.85432 3.45527C5.00869 3.36618 5.18381 3.3193 5.36205 3.31937C5.54029 3.31943 5.71537 3.36643 5.86968 3.45564Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
